import React from "react";

const Contact = () => {
  const contactInfo = [
    {
      icon: "📍",
      title: "Office Address",
      details: [
        "Komp. Pergudangan Natura Estate,",
        "Jl. Kw Pergudangan Dan Industri Parangloe, No. C8, Bira.",
        "Kec. Tamalanrea, Kota Makassar,",
        "Sulawesi Selatan, 90224",
      ],
    },
    {
      icon: "📞",
      title: "Phone Number",
      details: [
        {
          text: "+62 821 9359 4444",
          wa: "6282193594444",
          label: "Founder & Director",
          waMessage: "Hello, I'm interested in your products from India office. Please share catalog, price list, and shipping info. Thanks.",
        },
      ],
    },
    {
      icon: "✉️",
      title: "Email",
      details: [
        {
          text: "pt.citraromaindo@gmail.com",
          email: "pt.citraromaindo@gmail.com",
          label: "Response within 24h",
          emailSubject: "Inquiry from Website - PT Citra Aroma Indo",
          emailBody: "Hello, I'm interested in your products from India office. Please share catalog, price list, and shipping info. Thanks.",
        },
      ],
    },
    {
      icon: "🌏",
      title: "Offshore Office",
      details: [
        "New Town, Kolkata, India.",
        {
          text: "+918001025943",
          wa: "918001025943",
          label: "India Office",
          waMessage: "Hello, I'm interested in your products from India office. Please share catalog, price list, and shipping info. Thanks.",
        },
        {
          text: "skgasn@gmail.com",
          email: "skgasn@gmail.com",
          label: "India Office",
          emailSubject: "Inquiry from Website - India Office",
          emailBody: "Hello, I'm interested in your products from India office. Please share catalog, price list, and shipping info. Thanks.",
        },
      ],
    },
  ];

  const handleWhatsAppClick = (phoneNumber, message) => {
    const cleanNumber = phoneNumber.replace(/\D/g, "");
    window.open(`https://wa.me/${cleanNumber}?text=${message}`, "_blank");
  };

  return (
    <section
      id="contact"
      className="py-5"
      style={{
        backgroundColor: "#ffffff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Decoration */}
      <div
        className="position-absolute"
        style={{
          top: "-10%",
          left: "-5%",
          width: "min(400px, 50vw)",
          height: "min(400px, 50vw)",
          background:
            "radial-gradient(circle, rgba(182,139,64,0.03) 0%, transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />
      <div
        className="position-absolute"
        style={{
          bottom: "-10%",
          right: "-5%",
          width: "min(400px, 50vw)",
          height: "min(400px, 50vw)",
          background:
            "radial-gradient(circle, rgba(26,62,63,0.03) 0%, transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />

      <div className="container position-relative" style={{ zIndex: 1 }}>
        {/* Section Header */}
        <div className="text-center mb-5" data-aos="fade-down">
          <h5
            className="text-uppercase mb-3"
            style={{
              color: "#b68b40",
              fontSize: "clamp(0.9rem, 2vw, 1rem)",
              fontWeight: "600",
              letterSpacing: "4px",
            }}
          >
            Contact Us
          </h5>
          <h2
            style={{
              color: "#1a3e3f",
              fontSize: "clamp(2rem, 5vw, 2.5rem)",
              fontWeight: "600",
              marginBottom: "15px",
              lineHeight: "1.2",
            }}
          >
            Get In Touch With Us
          </h2>
          <p
            className="mx-auto"
            style={{
              color: "#6c757d",
              fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
              maxWidth: "700px",
            }}
          >
            Have questions about our products or need a sample? Reach out to us
            through the contact information below.
          </p>
          <div
            className="mx-auto"
            style={{
              width: "60px",
              height: "3px",
              background: "#b68b40",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          />
        </div>

        {/* Contact Information - Responsive Grid */}
        <div className="row g-4 mb-5">
          {contactInfo.map((item, index) => (
            <div
              className="col-12 col-md-6 col-lg-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div
                className="h-100 p-4 rounded-4 text-white d-flex flex-column"
                style={{
                  backgroundColor: index % 2 === 0 ? "#1a3e3f" : "#b68b40",
                  minHeight: "280px",
                  boxShadow: "0 15px 30px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 30px rgba(0,0,0,0.1)";
                }}
              >
                {/* Icon dan Title */}
                <div className="text-center mb-3">
                  <div
                    style={{
                      fontSize: "clamp(2rem, 5vw, 2.5rem)",
                      marginBottom: "10px",
                    }}
                  >
                    {item.icon}
                  </div>
                  <h3
                    className="fw-semibold"
                    style={{
                      fontSize: "clamp(1.1rem, 2.5vw, 1.2rem)",
                      marginBottom: "10px",
                      color: index % 2 === 0 ? "#e8d5b5" : "#1a3e3f",
                    }}
                  >
                    {item.title}
                  </h3>
                </div>

                {/* Konten */}
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  {item.details.map((detail, i) => {
                    // Untuk Phone Number - bisa klik ke WhatsApp dengan pesan otomatis
                    if (
                      (item.title === "Phone Number" || item.title === "Offshore Office") &&
                      typeof detail === "object" &&
                      detail.wa
                    ) {
                      return (
                        <div key={i} className="text-center">
                          <div
                            onClick={() => handleWhatsAppClick(detail.text, detail.waMessage)}
                            className="d-inline-block px-3 py-2 rounded-pill mb-2"
                            style={{
                              color: "white",
                              fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                              fontWeight: "600",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              backgroundColor: "rgba(255,255,255,0.1)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#25D366";
                              e.currentTarget.style.transform = "scale(1.05)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "rgba(255,255,255,0.1)";
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          >
                            <span className="me-2">📱</span>
                            {detail.text}
                          </div>
                          <span
                            className="d-block"
                            style={{
                              fontSize: "clamp(0.75rem, 2vw, 0.8rem)",
                              opacity: 0.7,
                            }}
                          >
                            {detail.label} • Click to WhatsApp
                          </span>
                        </div>
                      );
                    }

                    // Untuk Email - menggunakan href langsung dengan pesan otomatis
                    else if (
                      (item.title === "Email" || item.title === "Offshore Office") &&
                      typeof detail === "object" &&
                      detail.email
                    ) {
                      return (
                        <div key={i} className="text-center">
                          <a
                            href={`mailto:${detail.email}?subject=${detail.emailSubject}&body=${detail.emailBody}`}
                            className="d-inline-block px-3 py-2 rounded-pill mb-2 text-white text-decoration-none"
                            style={{
                              fontSize: "clamp(0.9rem, 2vw, 1rem)",
                              transition: "all 0.3s ease",
                              backgroundColor: "rgba(255,255,255,0.1)",
                              wordBreak: "break-all",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor =
                                index % 2 === 0 ? "#b68b40" : "#1a3e3f";
                              e.currentTarget.style.transform = "scale(1.05)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "rgba(255,255,255,0.1)";
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          >
                            <span className="me-2">✉️</span>
                            {detail.email}
                          </a>
                          <span
                            className="d-block"
                            style={{
                              fontSize: "clamp(0.75rem, 2vw, 0.8rem)",
                              opacity: 0.7,
                            }}
                          >
                            {detail.label} • Click to Email
                          </span>
                        </div>
                      );
                    }

                    // Untuk Address dan teks biasa (string)
                    else {
                      return (
                        <p
                          key={i}
                          className="text-center mb-1"
                          style={{
                            fontSize: "clamp(0.85rem, 2vw, 0.9rem)",
                            lineHeight: "1.6",
                            opacity: 0.9,
                          }}
                        >
                          {typeof detail === "string" ? detail : detail.text}
                        </p>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Map Section */}
        <div className="row" data-aos="fade-up">
          <div className="col-12">
            <div
              className="p-4 rounded-4"
              style={{
                backgroundColor: "#ffffff",
                boxShadow: "0 10px 40px rgba(0,0,0,0.05)",
                border: "1px solid #edf2f7",
              }}
            >
              <div className="d-flex align-items-center gap-3 mb-4">
                <span style={{ fontSize: "clamp(1.5rem, 3vw, 1.8rem)" }}>
                  📍
                </span>
                <div>
                  <h4
                    className="fw-semibold"
                    style={{
                      color: "#1a3e3f",
                      fontSize: "clamp(1.2rem, 3vw, 1.3rem)",
                      margin: 0,
                    }}
                  >
                    Our Location
                  </h4>
                  <p
                    style={{
                      color: "#6c757d",
                      fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                      margin: "5px 0 0",
                    }}
                  >
                    Komp. Pergudangan Natura Industrial Estate
                  </p>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  height: "clamp(300px, 50vw, 400px)",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
                }}
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3974.0374855624664!2d119.48059139678956!3d-5.097641699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dbefd98d0fe596b%3A0xea238b61c9717d95!2sKomp.%20Pergudangan%20Natura%20Industrial%20Estate%20No.%20A1!5e0!3m2!1sen!2sid!4v1770997691039!5m2!1sen!2sid"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Office Location"
                ></iframe>
              </div>

              {/* Address Detail */}
              <div
                className="mt-4 p-4 rounded-3"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderLeft: "4px solid #b68b40",
                }}
              >
                <p
                  style={{
                    color: "#1a3e3f",
                    fontSize: "clamp(0.95rem, 2vw, 1rem)",
                    lineHeight: "1.8",
                    margin: 0,
                    fontWeight: "500",
                  }}
                >
                  <strong style={{ color: "#b68b40" }}>
                    PT Citra Aroma Indo
                  </strong>
                  <br />
                  Komp. Pergudangan Natura Estate
                  <br />
                  Jl. Kw Pergudangan Dan Industri Parangloe, No. C8, Bira
                  <br />
                  Tamalanrea District, Makassar City <br />
                  South Sulawesi, 90224 <br />
                  Indonesia
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;